import Seo from "../components/Seo";

const FAQS = [
  {
    q: "Is HS Library Hangout run by Oak Lawn Public Library?",
    a: "No. HS Library Hangout is an independently organized parent group. It is not sponsored, managed, approved, or endorsed by Oak Lawn Public Library. Library staff do not manage events, registrations, supervision, or questions for this group.",
  },
  {
    q: "Who can attend?",
    a: "Homeschooled teens in grades 8-12 (ages 13-18), accompanied by a parent/guardian RSVP. A parent organizer is present for the entire event.",
  },
  {
    q: "Do I need to stay for the whole event?",
    a: "An adult parent organizer is present throughout, but this is not supervised childcare. Please review our Safety & Code of Conduct page for expectations about parent presence and pickup.",
  },
  {
    q: "Can younger siblings come along?",
    a: "No, gatherings are limited to homeschooled teens in grades 8-12 (ages 13-18) to keep games and conversation age-appropriate.",
  },
  {
    q: "How do I RSVP?",
    a: "Visit the Events page, open a Confirmed event, and fill out the RSVP form. You'll get a confirmation email with a link to verify your RSVP.",
  },
  {
    q: "What if the event is full?",
    a: "You can join the waitlist. If a confirmed spot opens up, we'll automatically promote the next family on the waitlist and email you.",
  },
  {
    q: "Can I change or cancel my RSVP?",
    a: "Yes. Every confirmation email includes a private link to manage your RSVP, where you can update details or cancel.",
  },
  {
    q: "What information do you collect, and how is it used?",
    a: "See our Privacy Policy for full details on what we collect, why, and how long we keep it.",
  },
];

export default function Faq() {
  return (
    <>
      <Seo title="FAQ" description="Frequently asked questions about HS Library Hangout board game gatherings." />
      <h1>Frequently Asked Questions</h1>
      {FAQS.map((item) => (
        <section className="card" key={item.q}>
          <h2>{item.q}</h2>
          <p>{item.a}</p>
        </section>
      ))}
    </>
  );
}
